export default __webpack_public_path__ + "static/media/lepri.0194804c.webp";